<template>
  <div class="main">
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/bakingmini/banner.jpg"
    ></landingBanner>
    <div class="part1">
   <newform titlecolor="#e73028" bag="#e73028" bordercolor="#e73028"></newform>
    </div>
    <div style="width:100%;height:10px;"></div>
    <div style="width100%;height:10px;background:#eee;"></div>
      <indexTitle title1="私人定制" title2="为你量身定制精品课程"></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/bakingmini/part2-1.jpg"
      />
     <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
         <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/bakingmini/part2-2.jpg"
      />
      </a>
    <div class="margin">
      <indexTitle title1="教学产品" title2="各式教学产品，有颜值更有内涵"></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="yellow">
        <van-swipe-item
          ><van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/bakingmini/part1-1.jpg"
        /></van-swipe-item>
        <van-swipe-item
          ><van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/bakingmini/part1-2.jpg"
        /></van-swipe-item>
        <van-swipe-item
          ><van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/bakingmini/part1-3.jpg"
        /></van-swipe-item>
        <van-swipe-item
          ><van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/bakingmini/part1-4.jpg"
        /></van-swipe-item>
      </van-swipe>
      <div style="width:100%;height:10px;"></div>
      <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
      <van-button color="#e73028" style="width:100%;font-size:17px;font-weight:600;">咨询老师</van-button></a>
    </div>
  
    <div style="width100%;height:10px;background:#eee;"></div>
    <div class="margin">
      <indexTitle title1="我们的优势" title2="中外双师授课，全程实操教学"></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/bakingmini/part3.jpg"
      />
      <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
      <van-button color="#e73028" style="width:100%;font-size:17px;font-weight:600;">咨询老师</van-button></a>
    </div>
    <div style="width100%;height:10px;background:#eee;"></div>
    <div class="margin">
      <indexTitle title1="教学环境" title2="欧式现代、酒店式的教学环境"></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/bakingmini/part4.jpg"
      />
    </div>
    <div style="width100%;height:10px;background:#eee;"></div>
    <div class="part1">
      <newform titlecolor="#e73028" bag="#e73028" bordercolor="#e73028"></newform>
    </div>
    <div class="h25px" style="width:100%;height:25px;"></div>
    <foot></foot>
  </div>
</template>

<script>
export default {
  components: {
    landingBanner: () => import('../../../components/common/landing-banner'),
    foot: () => import('@/components/foot/foot'),
    indexTitle: () => import('@/components/common/indexTitle'),
    footerForm: () => import('@/components/form/footerForm'),
    find2: () => import('@/components/common/find2'),
    newform: () => import("@/components/form/newform")
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.more {
  width: 100%;
  height: 110px;
  border-bottom: 1px solid #eee;
  padding: 10px 0;
}
.more-1 {
  width: 45%;
  height: 90px;
  margin-right: 10px;
  float: left;
}
.more-2 {
  height: 90px;
  float: left;
}
.more-2-words {
  font-size: 13px;
  color: #b9b9b9;
}
.fill {
  width: 100%;
}
.margin {
  width: 100%;
  padding: 0 10px 15px 10px;
}
.industry-form {
  width: 100%;
  background: rgb(162, 16, 29);
  padding: 17px;
  margin-top: -6px;
}
.form-insite {
  border-radius: 10px;
  background: #fff;
}
.content {
  width: 100%;
  padding: 10px;
  background: #fff;
}
.part2 {
  width: 100%;
  padding: 70px 30px 25px 30px;
  background-repeat: no-repeat;
  background-image: url(https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/industry/back.jpg);
  background-size: 100% 101%;
}
.button {
  width: 100%;
  text-align: center;
  margin-top: 10px;
}
</style>
